<!--海森介绍-->
<template>
  <div class="footer">
    <div class="footer-area">
      <div class="footer-left">
        <img src="static/footer/footerImg.png" class="footer-img"/>
        <p>Copyright © 2022 All rights reserved by FDC.</p>
      </div>
      <div class="footer-content">
        <h1>福玳，你可以信赖的数字化创意和医学服务合作伙伴！</h1>
        <h3>关注我们的企业微信，定期获得最新消息和优惠！</h3>
      </div>
      <div class="footer-right">
        <img src="static/footer/qiyewv.jpg" class="footer-ewm"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['headerMenuSelectedKey', 'shrinkMenuSelectedKey'],
  data() {
    return {
      headerMenuCurrentKey: this.headerMenuSelectedKey,
      shrinkMenuCurrentKey: this.shrinkMenuSelectedKey
    };
  },
  watch: {
    shrinkMenuSelectedKey(val) {
      this.shrinkMenuCurrentKey = val
    }

  },
  methods: {
    toPage(path, location) {
      if (path == this.headerMenuCurrentKey) {
        //本页时，传递给父页面当前选定的值
        this.$emit('toLocation', location)
      } else {
        //跳转到其他页面时，先储存一个location值，供其他页面挂载时候用
        localStorage.setItem("location", location)
        //路由跳转
        this.$router.push('/' + path);
      }
    },
  },
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}

.footer {
  background-color: rgba(209, 18, 28, 1);
  color: white;
  height: 189px;
  width: 1920px;
  position: absolute;
  bottom: 0;
  display: flex;
  align-content: center;
  justify-content: center;
}

.footer-area {
  height: 189px;
  width: 1400px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footer-img {
  width: 170px;
  height: 58px;
}

.footer-left {
  /*width: 350px;*/
  height: 189px;
  display: flex;
  align-content: center;
  justify-content: space-evenly;
  flex-direction: column;
}

.footer-left p {
  font-size: 14px;
}

.footer-content {
  width: 756px;
  height: 189px;
  background: url("../../static/footer/contact.svg") no-repeat;
  background-size: 770px 130px;
  background-position: 0 32px;
  display: flex;
  text-align: center;
  justify-content: center;
  flex-direction: column;
}

.footer-content h1 {
  font-size: 22px;
  color: rgba(209, 18, 28, 1);
  font-weight: bold;
}

.footer-content h3 {
  font-size: 14px;
  color: rgba(209, 18, 28, 1);
  font-weight: bold;
}

.footer-right {
  /*width: 154px;*/
  height: 189px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: end;
}
.footer-ewm {
  width: 135px;
  height: 135px;
  float: right;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue